import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Tag,
  Input,
  Table,
  Empty,
  Tooltip,
  Popconfirm,
} from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import {
  EditOutlined,
  PlusCircleOutlined,
  FilePdfOutlined,
  CheckCircleOutlined,
  FilterFilled,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  GetEstimatePdfApi,
  GetPartnerClientByIdApi,
  getClientEstimatesListApi,
  getPartnerEstimatesListApi,
  getQuotesListByProjectId,
} from "../ClientsApi";
import { FormattedMessage, useIntl } from "react-intl";
import {
  getEmployeesAPI,
  getQuoteTypeAPI,
  getStatusAPI,
} from "CommonComponents/Lookup/LookupAPI";
import { estimateStatusChangeAPI } from "features/OnBoarding/authenticateAPI";
import StatusEnum from "features/Enums/StatusEnum";
import { resetEstimateById } from "../ClientsSlice";
import CreateQuote from "features/Dashboard/CreateQuote";
function Estimates(props) {
  const { Search } = Input;
  const { Column } = Table;
  const dispatch = useDispatch();
  const { clientId, partnerId } = useParams();
  const intl = useIntl();
  const navigate = useNavigate();
  const companyId = localStorage.getItem("CompanyId");
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  const estimatesList = useSelector((state) => state.clients.estimatesList);
  const employeeList = useSelector((state) => state.lookup.employeesList);
  const client = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state.clients.partnerClientById);
  const totalPages = useSelector((state) => state.clients.totalPages);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const quoteTypes = useSelector((state) => state.lookup.quoteTypes);
  const selectedLanguage = localStorage.getItem("selectedlanguage");
  const [selectedQuoteTypeIds, setSelectedQuoteTypeIds] = useState([]);
  const [selectedStatusIds, setSelectedStatusIds] = useState([]);
  const [openQuoteModel, setOpenQuoteModel] = useState(false);

  const pagination = {
    pageNo: currentPage,
    pageSize: 10,
    searchQuery: searchTerm,
    quoteTypeIds: selectedQuoteTypeIds.length > 0 ? selectedQuoteTypeIds : null,
    statusIds: selectedStatusIds.length > 0 ? selectedStatusIds : null,
  };
  useEffect(() => {
    dispatch(getStatusAPI());
    dispatch(getEmployeesAPI());
    dispatch(resetEstimateById());
    dispatch(getQuoteTypeAPI());
  }, [dispatch]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const handleEditClick = (estimateid) => {
    navigate(
      partnerId && clientId
        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/projects/${props?.projectId}/${estimateid}/editestimate`
        : clientId
        ? `/${companyId}/${clientId}/client_details/${estimateid}/editestimate`
        : `/${companyId}/${partnerId}/partner_client_details/${estimateid}/editestimate`
    );
  };
  useEffect(() => {
    if (props.projectId) {
      dispatch(getQuotesListByProjectId(pagination, props.projectId));
    } else if (clientId) {
      dispatch(getClientEstimatesListApi(clientId, pagination));
    } else if (partnerId) {
      dispatch(getPartnerEstimatesListApi(partnerId, pagination));
    }
  }, [
    props.projectId,
    clientId,
    partnerId,
    dispatch,
    searchTerm,
    currentPage,
    selectedQuoteTypeIds,
    selectedStatusIds,
  ]);

  const statusMap = {
    1: { text: "Draft", textFr: "Brouillon", color: "gold" },
    2: { text: "Submitted", textFr: "Soumis", color: "blue" },
    3: { text: "Accepted", textFr: "Accepté", color: "green" },
    4: { text: "Rejected", textFr: "Rejeté", color: "red" },
  };
  const handlePrint = async (estimate) => {
    try {
      await Promise.all([
        dispatch(GetEstimatePdfApi(estimate.id)).then((response) => {
          if (response) {
            const base64 = response?.value?.pdfBase64;
            const fileName = `${estimate.estimateNo}.pdf`;
            const pdfDataUrl = `data:application/pdf;base64,${base64}`;

            const pdfWindow = window.open("", "_blank");

            if (pdfWindow) {
              pdfWindow.document.write(`
              <html>
                  <head><title>${fileName}</title></head>
                  <body style="margin:0">
                    <iframe width="100%" height="100%" src="${pdfDataUrl}" frameborder="0"></iframe>
                  </body>
              </html>
            `);
              pdfWindow.document.close();
            }
          }
        }),
      ]);
    } catch (e) {
      console.error("Error previewing PDF:", e);
    }
  };
  const getEmployeeNameById = (salesPersonId) => {
    const employee = employeeList?.find((item) => item?.id == salesPersonId);
    return employee ? `${employee.firstName} ${employee.lastName}` : "N/A";
  };
  const handleCreateWO = (estimateId) => {
    dispatch(estimateStatusChangeAPI(estimateId, StatusEnum?.Accepted?.id));
  };
  const handleAddEstimate = () => {
    const address =
      clientId && client?.address?.length > 0
        ? client.address[0]
        : partnerId && partner?.address?.length > 0
        ? partner.address[0]
        : null;

    const hasValidAddress =
      address &&
      (address.address1?.trim() ||
        address.address2?.trim() ||
        address.city?.trim() ||
        address.zip?.trim() ||
        address.provinceName?.trim() ||
        address.countryName?.trim() ||
        address.countryId ||
        address.provinceId);

    if (!hasValidAddress) {
      OpenNotificationWithIcon(
        "warning",
        "Common.Warning",
        "",
        "LeadView.AddressRequired"
      );
      return;
    }
    if (partnerId && clientId == null) {
      setOpenQuoteModel(true);
      dispatch(GetPartnerClientByIdApi(partnerId));
    } else {
      const targetUrl =
        partnerId && clientId
          ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/projects/${props?.projectId}/addestimate`
          : clientId
          ? `/${companyId}/${clientId}/client_details/addestimate`
          : `/${companyId}/${partnerId}/partner_client_details/addestimate`;
      navigate(targetUrl, {
        state: {
          projectId: props.projectId || null,
        },
      });
    }
  };

  return (
    <>
      <Row align="middle">
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Search
            placeholder={intl.formatMessage({
              id: "ClientDetails.placeholder.SearchByQuatationNumber",
            })}
            onSearch={handleSearch}
            allowClear
          />
        </Col>
        <Col
          xs={24}
          sm={16}
          md={16}
          lg={16}
          xl={16}
          className="text-right sm-md-10"
        >
          <Space>
            {(partnerId && clientId
              ? partner?.isActive && client?.isActive
              : partnerId
              ? partner?.isActive
              : client?.isActive) && (
              <Button type="primary" onClick={handleAddEstimate}>
                <PlusCircleOutlined />
                <FormattedMessage id="AddEstimate.AddEstimate" />
              </Button>
            )}
          </Space>
        </Col>
      </Row>
      <Table
        dataSource={estimatesList}
        scroll={{
          x: 900,
        }}
        pagination={{
          current: currentPage,
          total: totalPages * 10,
          showSizeChanger: false,
          onChange: handlePageChange,
        }}
        className="mt-10"
        bordered
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={intl.formatMessage({
                id: "NoData",
              })}
            />
          ),
        }}
      >
        <Column
          title={<FormattedMessage id="ClientDetails.QuatationNo" />}
          dataIndex="estimateNo"
          key="quateno"
          render={(_, record) => (
            <Link
              to={
                partnerId && clientId
                  ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/projects/${props?.projectId}/${record?.id}/viewquote`
                  : clientId
                  ? `/${companyId}/${clientId}/client_details/${record?.id}/viewquote`
                  : `/${companyId}/${partnerId}/partner_client_details/${record?.id}/viewquote`
              }
            >
              {record?.estimateNo}
            </Link>
          )}
        />

        {/* <Column
            title={<FormattedMessage id="ClientDetails.Date" />}
            dataIndex="dateTime"
            key="date"
          /> */}
        <Column
          title={<FormattedMessage id="ClientDetails.QuoteType" />}
          dataIndex="quoteTypeName"
          key="quoteTypeName"
          filterDropdown={({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }}>
              {quoteTypes?.map((type) => {
                const label =
                  selectedLanguage === "fr-FR" ? type.nameFr : type.nameEn;
                const checked = selectedQuoteTypeIds.includes(type.id);
                return (
                  <div key={type.id} style={{ marginBottom: 4 }}>
                    <label style={{ cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => {
                          const newSelected = checked
                            ? selectedQuoteTypeIds.filter(
                                (id) => id !== type.id
                              )
                            : [...selectedQuoteTypeIds, type.id];
                          setSelectedQuoteTypeIds(newSelected);
                          setCurrentPage(1);
                        }}
                        style={{ marginRight: 8 }}
                      />
                      {label}
                    </label>
                  </div>
                );
              })}
              <Button
                onClick={() => {
                  setSelectedQuoteTypeIds([]);
                  setCurrentPage(1);
                }}
                size="small"
                style={{ marginTop: 8, width: "100%" }}
              >
                {intl.formatMessage({ id: "Common.Reset" })}
              </Button>
            </div>
          )}
          filterIcon={(filtered) => (
            <FilterFilled
              style={{ color: filtered ? "#1890ff" : "white", fontSize: 15 }}
            />
          )}
          onFilter={(value, record) =>
            Array.isArray(value)
              ? value.includes(
                  selectedLanguage === "fr-FR"
                    ? record.quoteTypeNameFr || record.quoteTypeName
                    : record.quoteTypeName
                )
              : (selectedLanguage === "fr-FR"
                  ? record.quoteTypeNameFr || record.quoteTypeName
                  : record.quoteTypeName) === value
          }
          render={(_, record) =>
            selectedLanguage === "fr-FR"
              ? record.quoteTypeNameFr || record.quoteTypeName
              : record.quoteTypeName
          }
        />
        <Column
          title={<FormattedMessage id="ClientDetails.ExpiryDate" />}
          dataIndex="expiryDate"
          key="expirydate"
        />

        <Column
          title={<FormattedMessage id="ClientDetails.Amount" />}
          dataIndex="grandTotal"
          key="amount"
        />
        <Column
          title={<FormattedMessage id="Quote.SalesPerson" />}
          dataIndex="salesPersonId"
          key="salesPersonId"
          render={(text, record) => getEmployeeNameById(record.salesPersonId)}
        />

        <Column
          title={<FormattedMessage id="ClientDetails.Status" />}
          dataIndex="status"
          key="status"
          filterDropdown={({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }}>
              {Object.entries(statusMap).map(([id, statusInfo]) => {
                const statusId = Number(id);
                const checked = selectedStatusIds.includes(statusId);
                const label =
                  selectedLanguage === "fr-FR"
                    ? statusInfo.textFr
                    : statusInfo.text;
                return (
                  <div key={statusId} style={{ marginBottom: 4 }}>
                    <label style={{ cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => {
                          const newSelected = checked
                            ? selectedStatusIds.filter(
                                (sid) => sid !== statusId
                              )
                            : [...selectedStatusIds, statusId];
                          setSelectedStatusIds(newSelected);
                          setCurrentPage(1);
                        }}
                        style={{ marginRight: 8 }}
                      />
                      {label}
                    </label>
                  </div>
                );
              })}
              <Button
                onClick={() => {
                  setSelectedStatusIds([]);
                  setCurrentPage(1);
                }}
                size="small"
                style={{ marginTop: 8, width: "100%" }}
              >
                {intl.formatMessage({ id: "Common.Reset" })}
              </Button>
            </div>
          )}
          filterIcon={(filtered) => (
            <FilterFilled
              style={{ color: filtered ? "#1890ff" : "white", fontSize: 15 }}
            />
          )}
          onFilter={(value, record) =>
            Array.isArray(value)
              ? value.includes(record.estimateStatusId)
              : record.estimateStatusId === value
          }
          render={(text, record) => {
            const isDraftOrSubmitted =
              record.estimateStatusId === StatusEnum.Draft?.id ||
              record.estimateStatusId === StatusEnum.Submitted?.id;

            const today = new Date();
            const expiry = new Date(record.expiryDate);
            const isExpired =
              isDraftOrSubmitted &&
              new Date(expiry.toDateString()) <
                new Date(new Date().toDateString());

            if (isExpired) {
              const label = selectedLanguage === "fr-FR" ? "Expiré" : "Expired";
              return <Tag color="red">{label}</Tag>;
            }

            const statusInfo = statusMap[record.estimateStatusId] || {
              text: "Unknown",
              textFr: "Inconnu",
              color: "default",
            };
            const label =
              selectedLanguage === "fr-FR"
                ? statusInfo.textFr
                : statusInfo.text;
            return <Tag color={statusInfo.color}>{label}</Tag>;
          }}
        />
        <Column
          title={<FormattedMessage id="ClientDetails.Action" />}
          key="action"
          render={(_, record) => {
            const isDraftOrSubmitted =
              record.estimateStatusId === StatusEnum.Draft?.id ||
              record.estimateStatusId === StatusEnum.Submitted?.id;

            const today = new Date();
            const expiry = new Date(record.expiryDate);
            const isExpired =
              isDraftOrSubmitted &&
              new Date(expiry.toDateString()) <
                new Date(new Date().toDateString());

            const disableEdit =
              record.estimateStatusId === StatusEnum.Accepted?.id ||
              record.estimateStatusId === StatusEnum.Rejected?.id ||
              isExpired;

            return (
              <Space size="middle">
                <Tooltip
                  title={
                    disableEdit ? (
                      <FormattedMessage id="Quote.QuoteCannotBeEdited" />
                    ) : (
                      <FormattedMessage id="Common.Edit" />
                    )
                  }
                >
                  <span>
                    <Button
                      size="small"
                      disabled={disableEdit}
                      onClick={() =>
                        !disableEdit && handleEditClick(record?.id)
                      }
                    >
                      <EditOutlined />
                    </Button>
                  </span>
                </Tooltip>

                <Tooltip
                  title={<FormattedMessage id="ClientDetails.Preview" />}
                >
                  <Button onClick={() => handlePrint(record)} size="small">
                    <FilePdfOutlined />
                  </Button>
                </Tooltip>
              </Space>
            );
          }}
        />
      </Table>
      {openQuoteModel && (
        <CreateQuote
          open={openQuoteModel}
          onCancel={() => setOpenQuoteModel(false)}
          partnerId={partnerId}
          type="quote"
        />
      )}
    </>
  );
}

export default Estimates;
